import { render, staticRenderFns } from "./qualityTask.vue?vue&type=template&id=bd2ec7f4&scoped=true"
import script from "./qualityTask.vue?vue&type=script&lang=js"
export * from "./qualityTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2ec7f4",
  null
  
)

export default component.exports